import {Col, Container, Form, Row} from "react-bootstrap";
import { Tooltip } from 'react-tooltip'
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../selectors/auth";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../../services/axiosInstance";
import Helper from "../../../utils/Helper";
import _ from "lodash";
import { React, useEffect, useState } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCalculator, faCircleInfo, faFileArrowDown, faFileLines} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router";
import * as userSelectors from "../../../selectors/user";
import MarginStatementHeaderItem from "../components/MarginStatementHeaderItem";
import MarginStatementHeaderComponent from "../components/MarginStatementHeaderComponent";
import MarginStatementBodySection from "../components/MarginStatementBodySection";
import * as generalSelectors from "../../../selectors/general";
import { getGeneralDateMarginStatementValue } from "../../../selectors/general";
import { apiInstance } from "../../../services/httpService";
import Image from "react-bootstrap/Image";
import LoadingOverlay from "../../../components/LoadingOverlay";
import MarginStatementDisclaimerNote from "../MarginStatementDisclaimerNote";

function MarginStatement({ generalData }) {
  const dispatch = useDispatch();
  const [token, setToken] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];
  const minDate = new Date();
  minDate.setDate(date.getDate() - 31);
  const minDateFromNow = minDate.toISOString().split("T")[0];
  const [currentDate, setCurrentDate] = useState(dateNow);
  const [calMaxDate, setCalMaxDate] = useState(dateNow);
  const [calMinDate, setCalMinDate] = useState(minDateFromNow);
  const history = useHistory();
  const userState = useSelector((state) => state.user);
  const clientName = userSelectors.getUserName(userState);
  const userText = userSelectors.getUserAccountSelectedUserText(userState);
  const selectedCurrencyText = userSelectors.getUserAccountCurrencySelected(userState);

  useEffect(() => {
    const marginStatementDate = generalSelectors.getGeneralDateMarginStatementValue(generalData);
    if (!_.isEmpty(marginStatementDate)) {
      setCurrentDate(marginStatementDate);

      const reportDate = new Date(marginStatementDate);
      reportDate.setDate(reportDate.getDate() - 31);
      setCalMinDate(reportDate.toISOString().split("T")[0])
      setCalMaxDate(marginStatementDate)
    }
  }, [generalData]);

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const onChangeDate = (e) => {
    if (_.isEmpty(e.target.value)) {
      setCurrentDate(calMaxDate);
      return;
    }
    setCurrentDate(e.target.value);
  };

  const { isFetching, data } = useQuery({
    queryKey: ["margin-statement-report", { currentDate }],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`clientarea/statement/margin-statement?data_date=${currentDate}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    placeholderData: keepPreviousData,
    enabled: !_.isEmpty(token),
  });

  const onClickDownloadPDF = async () => {
    if(downloadLoading){
      return
    }
    const axios = apiInstance(
      {
        responseType: "blob",
        contentType: "application/pdf",
      },
      { responseType: "blob" },
    );
    try {
      setDownloadLoading(true);
      const response = await axios.get(
        `clientarea/statement/margin-statement?data_date=${currentDate}&pdf=1`,
      );
      if (response.status === 200) {
        const data = new Blob([response.data], { type: "application/pdf" });
        let downloadUrl = window.URL.createObjectURL(data);
        let downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.setAttribute(
          "download",
          `margin-statement-${currentDate}.pdf`,
        );
        downloadLink.click();
      }
    } catch (error) {
      axiosInstance.httpErrorHelpers(error);
    }
    finally {
      setDownloadLoading(false);

    }
  };

  const onclickMarginSimulator = () => {};
  return (
    <Container fluid>
      {/*// ======= Head Section ======== */}
      <div className="mb-3">
        <Row>
          <Col md={12} lg={6}>
            <div
                className={clsx(
                    "custom-table-title-container justify-content-lg-start mb-2 mb-lg-0 justify-content-center",
                )}
            >
              <p> {clientName} </p>
              <p> ( {userText} ) </p>
            </div>
          </Col>
          <Col md={12} lg={6}>
            <div className="d-flex align-items-center justify-content-lg-end  justify-content-center">
              <Tooltip id="datepicker-tooltip" />
              <FontAwesomeIcon
                  data-tooltip-id="datepicker-tooltip" data-tooltip-content="Historical data only available for 30 days."
                  className="me-2"
                  icon={faCircleInfo}
                  style={{marginLeft: "24px", color: "#b99559", cursor: "pointer"}}
              />
              <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="date"
                  min={calMinDate}
                  max={calMaxDate}
                  className="custom-settlement-datepicker-white"
                  value={currentDate}
                  onChange={onChangeDate}
              />
              <a
                  className="download-btn mx-2"
                  onClick={() => onClickDownloadPDF()}
              >
                <Image
                    src="/img/icon/download.png"
                    style={{width: "18px", objectFit: "contain"}}
                />
                <LoadingOverlay
                    isSemiLoading={true}
                    loading={downloadLoading}
                ></LoadingOverlay>
              </a>
            </div>
          </Col>
        </Row>
      </div>
      <hr className="line-gold"/>
      <MarginStatementHeaderComponent loading={isFetching} data={data}/>
      <div
          className={"primary-border-table-border"}
          style={{backgroundColor: "white"}}
      >
        <div
            className={clsx(
                "d-flex custom-card-label-container align-items-center",
            )}
        >
          <FontAwesomeIcon
              icon={faFileLines}
              className="fa-2x"
              style={{ marginRight: "10px", color: "white" }}
          />
          <h2>Margin Statement</h2>
        </div>
        <MarginStatementBodySection
            loading={isFetching}
            data={data}
        ></MarginStatementBodySection>
      </div>
      <MarginStatementDisclaimerNote></MarginStatementDisclaimerNote>
    </Container>
  );
}

export default MarginStatement;
